import {
  Building2,
  MapPin,
  Train,
  Link2,
  ShoppingBag,
  KeyRound,
  ShieldCheck,
  TrendingUp,
} from "lucide-react";

export const genSphereHighlights = [
  {
    title: "Freehold Residence",
    description: "Permanent ownership in a prime city-centre location.",
    icon: Building2,
  },
  {
    title: "440m to JB Sentral",
    description: "Walking distance to JB Sentral.",
    icon: MapPin,
  },
  {
    title: "700m to RTS Link",
    description: "Near Bukit Chagar RTS station connecting JB to Singapore.",
    icon: Train,
  },
  {
    title: "Link Bridge to JB Sentral",
    description:
      "Proposed direct connection* linked to the existing link bridge to JB Sentral.",
    icon: Link2,
  },
  {
    title: "Retail convenience",
    description: "Retail convenience ready below apartment.",
    icon: ShoppingBag,
  },
  {
    title: "Dual Key Concept",
    description: "Dual key flexibility layout design available for all units.",
    icon: KeyRound,
  },
  {
    title: "Trusted Developer",
    description: "Built by an award-winning and reliable development team.",
    icon: ShieldCheck,
  },
  {
    title: "High Investment Potential",
    description:
      "Strategically located to support long-term value growth and rental returns.",
    icon: TrendingUp,
  },
];